import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';

/**
 * Custom scaffolder field extensions (new frontend system: FormFieldBlueprint
 * attached to the scaffolder plugin's page).
 */
const roleGroupsPickerFormField = FormFieldBlueprint.make({
  name: 'role-groups-picker',
  params: {
    field: () =>
      Promise.all([import('./RoleGroupsPicker'), import('./roleGroups')]).then(
        ([{ RoleGroupsPicker }, { validateRoleGroups }]) =>
          createFormField({
            name: 'RoleGroupsPicker',
            component: RoleGroupsPicker,
            validation: validateRoleGroups,
          }),
      ),
  },
});

const serviceAccountRolesPickerFormField = FormFieldBlueprint.make({
  name: 'service-account-roles-picker',
  params: {
    field: () =>
      Promise.all([
        import('./ServiceAccountRolesPicker'),
        import('./serviceAccountRoles'),
      ]).then(
        ([{ ServiceAccountRolesPicker }, { validateServiceAccountRoles }]) =>
          createFormField({
            name: 'ServiceAccountRolesPicker',
            component: ServiceAccountRolesPicker,
            validation: validateServiceAccountRoles,
          }),
      ),
  },
});

const teamPickerFormField = FormFieldBlueprint.make({
  name: 'team-picker',
  params: {
    field: () =>
      import('./TeamPicker').then(({ TeamPicker }) =>
        createFormField({ name: 'TeamPicker', component: TeamPicker }),
      ),
  },
});

export const scaffolderFieldsModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [
    roleGroupsPickerFormField,
    serviceAccountRolesPickerFormField,
    teamPickerFormField,
  ],
});
